import React, { useMemo } from "react";
import { Typography } from "../Typography/Typography";
//
import { useFieldErrorMessage } from "../inputUtils";
import { Controller } from "react-hook-form";

import { TextInputProps } from "../TextInput/TextInput";

import { type Control } from "react-hook-form";

import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface HookFormPhoneNumberInputProps extends TextInputProps {
  // sorry for the `any` typing, generics are hard to implement with forwardRef so ommitting for now.
  // this SHOULD be "any Control<T> where T extends {phoneNumber: string}"
  control: Control<any>;
}

export const HookFormPhoneNumberInput = React.forwardRef<HTMLInputElement, HookFormPhoneNumberInputProps>(
  (props, ref) => {
    const { label, isRequired, hookFormFieldError, control, ...inputProps } = props;

    const error = useFieldErrorMessage(hookFormFieldError);

    const inputStyle = useMemo(() => {
      const borderClassName = error ? "border-red" : "border-grey";
      return `${borderClassName} mt-1 min-h-12 min-w-full rounded-xl border pl-2`;
    }, [error]);

    return (
      <>
        <Typography className={error ? "text-red" : ""}>
          {props.label}
          {isRequired ? "*" : ""}
        </Typography>

        <Controller
          name="phoneNumber"
          control={control}
          rules={{
            validate: (value) => isValidPhoneNumber(value),
          }}
          render={({ field: { onChange, value } }) => {
            console.log(value);
            return (
              <PhoneInput
                {...inputProps}
                value={value}
                className={inputStyle}
                defaultCountry="US"
                id="phoneNumber"
                onChange={(val) => {
                  // prevent setting to `undefined` - hook form and phone number input
                  // isn't type safe enough to account for this sadly
                  onChange(val ?? "");
                }}
              />
            );
          }}
        />

        {error ? <p className="text-red">{error} </p> : null}
      </>
    );
  },
);

HookFormPhoneNumberInput.displayName = "HookFormPhoneNumberInput";
